import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Window, Loading, EmptyState } from "../../components/VB";

export default function JadwalShift() {
  const [items, setItems] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [a, s] = await Promise.all([api.get("/shift-assignments"), api.get("/shifts")]);
        setItems(a.data); setShifts(s.data);
      } catch {}
      setLoading(false);
    })();
  }, []);

  const shiftDetail = (id) => shifts.find((s) => s.id === id);

  return (
    <Window title="Jadwal Shift Saya">
      {loading ? <Loading /> : items.length === 0 ? <EmptyState message="Belum ada jadwal shift" /> : (
        <table className="vb-table">
          <thead><tr><th>Shift</th><th>Jam Kerja</th><th>Mulai</th><th>Selesai</th><th>Status</th></tr></thead>
          <tbody>
            {items.map((it) => {
              const s = shiftDetail(it.shift_id);
              return (
                <tr key={it.id}>
                  <td>{s?.nama || "-"}</td>
                  <td>{s ? `${s.jam_masuk} - ${s.jam_pulang}` : "-"}</td>
                  <td>{it.tanggal_mulai}</td>
                  <td>{it.tanggal_selesai || "-"}</td>
                  <td>{it.status_aktif ? "Aktif" : "Nonaktif"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </Window>
  );
}
